import { render, staticRenderFns } from "./JwSelectPyfa.vue?vue&type=template&id=4e0e2172"
import script from "./JwSelectPyfa.vue?vue&type=script&lang=js"
export * from "./JwSelectPyfa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports